import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
import mixin from './mixin';
import itemMixin from './item-mixin';
import { findNodeUpperByClasses } from '@/libs/util';
export default {
  name: 'CollapsedMenu',
  mixins: [mixin, itemMixin],
  props: {
    hideTitle: {
      type: Boolean,
      default: false
    },
    rootIconSize: {
      type: Number,
      default: 16
    }
  },
  data: function data() {
    return {
      placement: 'right-end'
    };
  },
  methods: {
    handleClick: function handleClick(name) {
      this.$emit('on-click', name);
    },
    handleMousemove: function handleMousemove(event, children) {
      var pageY = event.pageY;
      var height = children.length * 38;
      var isOverflow = pageY + height < window.innerHeight;
      this.placement = isOverflow ? 'right-start' : 'right-end';
    }
  },
  mounted: function mounted() {
    var dropdown = findNodeUpperByClasses(this.$refs.dropdown.$el, ['ivu-select-dropdown', 'ivu-dropdown-transfer']);
    if (dropdown) dropdown.style.overflow = 'visible';
  }
};